<template>
  <div>
    <sprite class="raypro-logo" name="raypro_logo"></sprite>
  </div>
</template>

<script>
import Sprite from './Sprite.vue'
import {mapGetters} from 'vuex'

export default {
  components: {Sprite},
}

</script>

<style lang="sass">
  @import '../../styles/base/variables'

  .ray
    fill: #2E96D6

  .pro
    fill: #003057

  .raypro-logo
    width: 100px
    height: 30px
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/Logo.vue